import * as React from "react";
import * as ReactRedux from "react-redux";
import * as Redux from "redux";
import ReactDOM from "react-dom";
import ReactCollapse from "react-collapse";
import * as ReactCustomScrollBars from "react-custom-scrollbars";
import * as CommonComponents from "./dnn-common-components";
import ReduxImmutableStateInvariant from "redux-immutable-state-invariant";
import ReduxThunk from "redux-thunk";
import ReactWidgets from "react-widgets";
import Promise from "es6-promise";
import PersonaBarComponents from "./components/persona-bar-components";

if (!window.dnn) {
    window.dnn = {};
}
if (!window.dnn.nodeModules) {
    window.dnn.nodeModules = {};
}

window.dnn.nodeModules.React = React;
window.dnn.nodeModules.Redux = Redux;
window.dnn.nodeModules.ReactRedux = ReactRedux;
window.dnn.nodeModules.ReactDOM = ReactDOM;
window.dnn.nodeModules.ReactCollapse = ReactCollapse;
window.dnn.nodeModules.ReactCustomScrollBars = ReactCustomScrollBars;
window.dnn.nodeModules.ReactWidgets = ReactWidgets;
window.dnn.nodeModules.CommonComponents = CommonComponents;
window.dnn.nodeModules.PersonaBarComponents = PersonaBarComponents;
window.dnn.nodeModules.ReduxImmutableStateInvariant = ReduxImmutableStateInvariant;
window.dnn.nodeModules.ReduxThunk = ReduxThunk;
window.dnn.nodeModules.Es6Promise = Promise;

// import accumulate from "react/lib/accumulate";
// import accumulateInto from "react/lib/accumulateInto";
// import adler32 from "react/lib/adler32";
// import AutoFocusUtils from "react/lib/AutoFocusUtils";
// import BeforeInputEventPlugin from "react/lib/BeforeInputEventPlugin";
// import CallbackQueue from "react/lib/CallbackQueue";
// import canDefineProperty from "react/lib/canDefineProperty";
// import ChangeEventPlugin from "react/lib/ChangeEventPlugin";
// import checkReactTypeSpec from "react/lib/checkReactTypeSpec";
// import createMicrosoftUnsafeLocalFunction from "react/lib/createMicrosoftUnsafeLocalFunction";
// import CSSProperty from "react/lib/CSSProperty";
// import CSSPropertyOperations from "react/lib/CSSPropertyOperations";
// import Danger from "react/lib/Danger";
// import dangerousStyleValue from "react/lib/dangerousStyleValue";
// import DefaultEventPluginOrder from "react/lib/DefaultEventPluginOrder";
// import deprecated from "react/lib/deprecated";
// import DisabledInputUtils from "react/lib/DisabledInputUtils";
// import DOMChildrenOperations from "react/lib/DOMChildrenOperations";
// import DOMLazyTree from "react/lib/DOMLazyTree";
// import DOMNamespaces from "react/lib/DOMNamespaces";
// import DOMProperty from "react/lib/DOMProperty";
// import DOMPropertyOperations from "react/lib/DOMPropertyOperations";
// import EnterLeaveEventPlugin from "react/lib/EnterLeaveEventPlugin";
// import escapeTextContentForBrowser from "react/lib/escapeTextContentForBrowser";
// import EventConstants from "react/lib/EventConstants";
// import EventPluginHub from "react/lib/EventPluginHub";
// import EventPluginRegistry from "react/lib/EventPluginRegistry";
// import EventPluginUtils from "react/lib/EventPluginUtils";
// import EventPropagators from "react/lib/EventPropagators";
// import FallbackCompositionState from "react/lib/FallbackCompositionState";
// import findDOMNode from "react/lib/findDOMNode";
// import findNodeHandle from "react/lib/findNodeHandle";
// import flattenChildren from "react/lib/flattenChildren";
// import forEachAccumulated from "react/lib/forEachAccumulated";
// import getEventCharCode from "react/lib/getEventCharCode";
// import getEventKey from "react/lib/getEventKey";
// import getEventModifierState from "react/lib/getEventModifierState";
// import getEventTarget from "react/lib/getEventTarget";
// import getHostComponentFromComposite from "react/lib/getHostComponentFromComposite";
// import getIteratorFn from "react/lib/getIteratorFn";
// import getNodeForCharacterOffset from "react/lib/getNodeForCharacterOffset";
// import getTestDocument from "react/lib/getTestDocument";
// import getTextContentAccessor from "react/lib/getTextContentAccessor";
// import getVendorPrefixedEventName from "react/lib/getVendorPrefixedEventName";
// import HTMLDOMPropertyConfig from "react/lib/HTMLDOMPropertyConfig";
// import instantiateReactComponent from "react/lib/instantiateReactComponent";
// import isEventSupported from "react/lib/isEventSupported";
// import isTextInputElement from "react/lib/isTextInputElement";
// import KeyEscapeUtils from "react/lib/KeyEscapeUtils";
// import LinkedStateMixin from "react/lib/LinkedStateMixin";
// import LinkedValueUtils from "react/lib/LinkedValueUtils";
// import onlyChild from "react/lib/onlyChild";
// import PooledClass from "react/lib/PooledClass";
// import quoteAttributeValueForBrowser from "react/lib/quoteAttributeValueForBrowser";
// import ReactBrowserEventEmitter from "react/lib/ReactBrowserEventEmitter";
// import ReactChildReconciler from "react/lib/ReactChildReconciler";
// import ReactChildren from "react/lib/ReactChildren";
// import ReactChildrenMutationWarningHook from "react/lib/ReactChildrenMutationWarningHook";
// import ReactClass from "react/lib/ReactClass";
// import ReactComponent from "react/lib/ReactComponent";
// import ReactComponentBrowserEnvironment from "react/lib/ReactComponentBrowserEnvironment";
// import ReactComponentEnvironment from "react/lib/ReactComponentEnvironment";
// import reactComponentExpect from "react/lib/reactComponentExpect";
// import ReactComponentTreeDevtool from "react/lib/ReactComponentTreeDevtool";
// import ReactComponentTreeHook from "react/lib/ReactComponentTreeHook";
// import ReactComponentTreeTestUtils from "react/lib/ReactComponentTreeTestUtils";
// import ReactCompositeComponent from "react/lib/ReactCompositeComponent";
// import ReactCSSTransitionGroup from "react/lib/ReactCSSTransitionGroup";
// import ReactCSSTransitionGroupChild from "react/lib/ReactCSSTransitionGroupChild";
// import ReactCurrentOwner from "react/lib/ReactCurrentOwner";
// import ReactDebugTool from "react/lib/ReactDebugTool";
// import ReactDefaultBatchingStrategy from "react/lib/ReactDefaultBatchingStrategy";
// import ReactDefaultInjection from "react/lib/ReactDefaultInjection";
// import ReactDOMButton from "react/lib/ReactDOMButton";
// import ReactDOMComponent from "react/lib/ReactDOMComponent";
// import ReactDOMComponentFlags from "react/lib/ReactDOMComponentFlags";
// import ReactDOMComponentTree from "react/lib/ReactDOMComponentTree";
// import ReactDOMContainerInfo from "react/lib/ReactDOMContainerInfo";
// import ReactDOMEmptyComponent from "react/lib/ReactDOMEmptyComponent";
// import ReactDOMFactories from "react/lib/ReactDOMFactories";
// import ReactDOMFeatureFlags from "react/lib/ReactDOMFeatureFlags";
// import ReactDOMIDOperations from "react/lib/ReactDOMIDOperations";
// import ReactDOMInput from "react/lib/ReactDOMInput";
// import ReactDOMNullInputValuePropHook from "react/lib/ReactDOMNullInputValuePropHook";
// import ReactDOMOption from "react/lib/ReactDOMOption";
// import ReactDOMSelect from "react/lib/ReactDOMSelect";
// import ReactDOMSelection from "react/lib/ReactDOMSelection";
// import ReactDOMServer from "react/lib/ReactDOMServer";
// import ReactDOMTextarea from "react/lib/ReactDOMTextarea";
// import ReactDOMTextComponent from "react/lib/ReactDOMTextComponent";
// import ReactDOMTreeTraversal from "react/lib/ReactDOMTreeTraversal";
// import ReactDOMUnknownPropertyHook from "react/lib/ReactDOMUnknownPropertyHook";
// import ReactElement from "react/lib/ReactElement";
// import ReactElementValidator from "react/lib/ReactElementValidator";
// import ReactEmptyComponent from "react/lib/ReactEmptyComponent";
// import ReactErrorUtils from "react/lib/ReactErrorUtils";
// import ReactEventEmitterMixin from "react/lib/ReactEventEmitterMixin";
// import ReactEventListener from "react/lib/ReactEventListener";
// import ReactFeatureFlags from "react/lib/ReactFeatureFlags";
// import ReactFragment from "react/lib/ReactFragment";
// import ReactHostComponent from "react/lib/ReactHostComponent";
// import ReactHostOperationHistoryHook from "react/lib/ReactHostOperationHistoryHook";
// import ReactInjection from "react/lib/ReactInjection";
// import ReactInputSelection from "react/lib/ReactInputSelection";
// import ReactInstanceHandles from "react/lib/ReactInstanceHandles";
// import ReactInstanceMap from "react/lib/ReactInstanceMap";
// import ReactInstrumentation from "react/lib/ReactInstrumentation";
// import ReactInvalidSetStateWarningHook from "react/lib/ReactInvalidSetStateWarningHook";
// import ReactLink from "react/lib/ReactLink";
// import ReactMarkupChecksum from "react/lib/ReactMarkupChecksum";
// import ReactMultiChild from "react/lib/ReactMultiChild";
// import ReactMultiChildUpdateTypes from "react/lib/ReactMultiChildUpdateTypes";
// import ReactNodeTypes from "react/lib/ReactNodeTypes";
// import ReactOwner from "react/lib/ReactOwner";
// import ReactPerf from "react/lib/ReactPerf";
// import reactProdInvariant from "react/lib/reactProdInvariant";
// import ReactPropTypeLocationNames from "react/lib/ReactPropTypeLocationNames";
// import ReactPropTypeLocations from "react/lib/ReactPropTypeLocations";
// import ReactPropTypes from "react/lib/ReactPropTypes";
// import ReactPropTypesSecret from "react/lib/ReactPropTypesSecret";
// import ReactPureComponent from "react/lib/ReactPureComponent";
// import ReactReconciler from "react/lib/ReactReconciler";
// import ReactReconcileTransaction from "react/lib/ReactReconcileTransaction";
// import ReactRef from "react/lib/ReactRef";
// import ReactServerBatchingStrategy from "react/lib/ReactServerBatchingStrategy";
// import ReactServerRendering from "react/lib/ReactServerRendering";
// import ReactServerRenderingTransaction from "react/lib/ReactServerRenderingTransaction";
// import ReactServerUpdateQueue from "react/lib/ReactServerUpdateQueue";
// import ReactSimpleEmptyComponent from "react/lib/ReactSimpleEmptyComponent";
// import ReactStateSetters from "react/lib/ReactStateSetters";
// import ReactTestMount from "react/lib/ReactTestMount";
// import ReactTestReconcileTransaction from "react/lib/ReactTestReconcileTransaction";
// import ReactTestRenderer from "react/lib/ReactTestRenderer";
// import ReactTestUtils from "react/lib/ReactTestUtils";
// import ReactTransitionChildMapping from "react/lib/ReactTransitionChildMapping";
// import ReactTransitionEvents from "react/lib/ReactTransitionEvents";
// import ReactTransitionGroup from "react/lib/ReactTransitionGroup";
// import ReactUMDEntry from "react/lib/ReactUMDEntry";
// import ReactUpdateQueue from "react/lib/ReactUpdateQueue";
// import ReactUpdates from "react/lib/ReactUpdates";
// import ReactVersion from "react/lib/ReactVersion";
// import ReactWithAddons from "react/lib/ReactWithAddons";
// import ReactWithAddonsUMDEntry from "react/lib/ReactWithAddonsUMDEntry";
// import renderSubtreeIntoContainer from "react/lib/renderSubtreeIntoContainer";
// import ResponderEventPlugin from "react/lib/ResponderEventPlugin";
// import ResponderSyntheticEvent from "react/lib/ResponderSyntheticEvent";
// import ResponderTouchHistoryStore from "react/lib/ResponderTouchHistoryStore";
// import SelectEventPlugin from "react/lib/SelectEventPlugin";
// import setInnerHTML from "react/lib/setInnerHTML";
// import setTextContent from "react/lib/setTextContent";
// import shallowCompare from "react/lib/shallowCompare";
// import shouldUpdateReactComponent from "react/lib/shouldUpdateReactComponent";
// import SimpleEventPlugin from "react/lib/SimpleEventPlugin";
// import sliceChildren from "react/lib/sliceChildren";
// import SVGDOMPropertyConfig from "react/lib/SVGDOMPropertyConfig";
// import SyntheticAnimationEvent from "react/lib/SyntheticAnimationEvent";
// import SyntheticClipboardEvent from "react/lib/SyntheticClipboardEvent";
// import SyntheticCompositionEvent from "react/lib/SyntheticCompositionEvent";
// import SyntheticDragEvent from "react/lib/SyntheticDragEvent";
// import SyntheticEvent from "react/lib/SyntheticEvent";
// import SyntheticFocusEvent from "react/lib/SyntheticFocusEvent";
// import SyntheticInputEvent from "react/lib/SyntheticInputEvent";
// import SyntheticKeyboardEvent from "react/lib/SyntheticKeyboardEvent";
// import SyntheticMouseEvent from "react/lib/SyntheticMouseEvent";
// import SyntheticTouchEvent from "react/lib/SyntheticTouchEvent";
// import SyntheticTransitionEvent from "react/lib/SyntheticTransitionEvent";
// import SyntheticUIEvent from "react/lib/SyntheticUIEvent";
// import SyntheticWheelEvent from "react/lib/SyntheticWheelEvent";
// import TapEventPlugin from "react/lib/TapEventPlugin";
// import TouchHistoryMath from "react/lib/TouchHistoryMath";
// import Transaction from "react/lib/Transaction";
// import traverseAllChildren from "react/lib/traverseAllChildren";
// import update from "react/lib/update";
// import validateDOMNesting from "react/lib/validateDOMNesting";
// import ViewportMetrics from "react/lib/ViewportMetrics";
// window.dnn.accumulate = accumulate;
// window.dnn.accumulateInto = accumulateInto;
// window.dnn.adler32 = adler32;
// window.dnn.AutoFocusUtils = AutoFocusUtils;
// window.dnn.BeforeInputEventPlugin = BeforeInputEventPlugin;
// window.dnn.CallbackQueue = CallbackQueue;
// window.dnn.canDefineProperty = canDefineProperty;
// window.dnn.ChangeEventPlugin = ChangeEventPlugin;
// window.dnn.checkReactTypeSpec = checkReactTypeSpec;
// window.dnn.createMicrosoftUnsafeLocalFunction = createMicrosoftUnsafeLocalFunction;
// window.dnn.CSSProperty = CSSProperty;
// window.dnn.CSSPropertyOperations = CSSPropertyOperations;
// window.dnn.Danger = Danger;
// window.dnn.dangerousStyleValue = dangerousStyleValue;
// window.dnn.DefaultEventPluginOrder = DefaultEventPluginOrder;
// window.dnn.deprecated = deprecated;
// window.dnn.DisabledInputUtils = DisabledInputUtils;
// window.dnn.DOMChildrenOperations = DOMChildrenOperations;
// window.dnn.DOMLazyTree = DOMLazyTree;
// window.dnn.DOMNamespaces = DOMNamespaces;
// window.dnn.DOMProperty = DOMProperty;
// window.dnn.DOMPropertyOperations = DOMPropertyOperations;
// window.dnn.EnterLeaveEventPlugin = EnterLeaveEventPlugin;
// window.dnn.escapeTextContentForBrowser = escapeTextContentForBrowser;
// window.dnn.EventConstants = EventConstants;
// window.dnn.EventPluginHub = EventPluginHub;
// window.dnn.EventPluginRegistry = EventPluginRegistry;
// window.dnn.EventPluginUtils = EventPluginUtils;
// window.dnn.EventPropagators = EventPropagators;
// window.dnn.FallbackCompositionState = FallbackCompositionState;
// window.dnn.findDOMNode = findDOMNode;
// window.dnn.findNodeHandle = findNodeHandle;
// window.dnn.flattenChildren = flattenChildren;
// window.dnn.forEachAccumulated = forEachAccumulated;
// window.dnn.getEventCharCode = getEventCharCode;
// window.dnn.getEventKey = getEventKey;
// window.dnn.getEventModifierState = getEventModifierState;
// window.dnn.getEventTarget = getEventTarget;
// window.dnn.getHostComponentFromComposite = getHostComponentFromComposite;
// window.dnn.getIteratorFn = getIteratorFn;
// window.dnn.getNodeForCharacterOffset = getNodeForCharacterOffset;
// window.dnn.getTestDocument = getTestDocument;
// window.dnn.getTextContentAccessor = getTextContentAccessor;
// window.dnn.getVendorPrefixedEventName = getVendorPrefixedEventName;
// window.dnn.HTMLDOMPropertyConfig = HTMLDOMPropertyConfig;
// window.dnn.instantiateReactComponent = instantiateReactComponent;
// window.dnn.isEventSupported = isEventSupported;
// window.dnn.isTextInputElement = isTextInputElement;
// window.dnn.KeyEscapeUtils = KeyEscapeUtils;
// window.dnn.LinkedStateMixin = LinkedStateMixin;
// window.dnn.LinkedValueUtils = LinkedValueUtils;
// window.dnn.onlyChild = onlyChild;
// window.dnn.PooledClass = PooledClass;
// window.dnn.quoteAttributeValueForBrowser = quoteAttributeValueForBrowser;
// window.dnn.React = React;
// window.dnn.ReactBrowserEventEmitter = ReactBrowserEventEmitter;
// window.dnn.ReactChildReconciler = ReactChildReconciler;
// window.dnn.ReactChildren = ReactChildren;
// window.dnn.ReactChildrenMutationWarningHook = ReactChildrenMutationWarningHook;
// window.dnn.ReactClass = ReactClass;
// window.dnn.ReactComponent = ReactComponent;
// window.dnn.ReactComponentBrowserEnvironment = ReactComponentBrowserEnvironment;
// window.dnn.ReactComponentEnvironment = ReactComponentEnvironment;
// window.dnn.reactComponentExpect = reactComponentExpect;
// window.dnn.ReactComponentTreeDevtool = ReactComponentTreeDevtool;
// window.dnn.ReactComponentTreeHook = ReactComponentTreeHook;
// window.dnn.ReactComponentTreeTestUtils = ReactComponentTreeTestUtils;
// window.dnn.ReactCompositeComponent = ReactCompositeComponent;
// window.dnn.ReactCSSTransitionGroup = ReactCSSTransitionGroup;
// window.dnn.ReactCSSTransitionGroupChild = ReactCSSTransitionGroupChild;
// window.dnn.ReactCurrentOwner = ReactCurrentOwner;
// window.dnn.ReactDebugTool = ReactDebugTool;
// window.dnn.ReactDefaultBatchingStrategy = ReactDefaultBatchingStrategy;
// window.dnn.ReactDefaultInjection = ReactDefaultInjection;
// window.dnn.ReactDOM = ReactDOM;
// window.dnn.ReactDOMButton = ReactDOMButton;
// window.dnn.ReactDOMComponent = ReactDOMComponent;
// window.dnn.ReactDOMComponentFlags = ReactDOMComponentFlags;
// window.dnn.ReactDOMComponentTree = ReactDOMComponentTree;
// window.dnn.ReactDOMContainerInfo = ReactDOMContainerInfo;
// window.dnn.ReactDOMEmptyComponent = ReactDOMEmptyComponent;
// window.dnn.ReactDOMFactories = ReactDOMFactories;
// window.dnn.ReactDOMFeatureFlags = ReactDOMFeatureFlags;
// window.dnn.ReactDOMIDOperations = ReactDOMIDOperations;
// window.dnn.ReactDOMInput = ReactDOMInput;
// window.dnn.ReactDOMNullInputValuePropHook = ReactDOMNullInputValuePropHook;
// window.dnn.ReactDOMOption = ReactDOMOption;
// window.dnn.ReactDOMSelect = ReactDOMSelect;
// window.dnn.ReactDOMSelection = ReactDOMSelection;
// window.dnn.ReactDOMServer = ReactDOMServer;
// window.dnn.ReactDOMTextarea = ReactDOMTextarea;
// window.dnn.ReactDOMTextComponent = ReactDOMTextComponent;
// window.dnn.ReactDOMTreeTraversal = ReactDOMTreeTraversal;
// window.dnn.ReactDOMUnknownPropertyHook = ReactDOMUnknownPropertyHook;
// window.dnn.ReactElement = ReactElement;
// window.dnn.ReactElementValidator = ReactElementValidator;
// window.dnn.ReactEmptyComponent = ReactEmptyComponent;
// window.dnn.ReactErrorUtils = ReactErrorUtils;
// window.dnn.ReactEventEmitterMixin = ReactEventEmitterMixin;
// window.dnn.ReactEventListener = ReactEventListener;
// window.dnn.ReactFeatureFlags = ReactFeatureFlags;
// window.dnn.ReactFragment = ReactFragment;
// window.dnn.ReactHostComponent = ReactHostComponent;
// window.dnn.ReactHostOperationHistoryHook = ReactHostOperationHistoryHook;
// window.dnn.ReactInjection = ReactInjection;
// window.dnn.ReactInputSelection = ReactInputSelection;
// window.dnn.ReactInstanceHandles = ReactInstanceHandles;
// window.dnn.ReactInstanceMap = ReactInstanceMap;
// window.dnn.ReactInstrumentation = ReactInstrumentation;
// window.dnn.ReactInvalidSetStateWarningHook = ReactInvalidSetStateWarningHook;
// window.dnn.ReactLink = ReactLink;
// window.dnn.ReactMarkupChecksum = ReactMarkupChecksum;
// window.dnn.ReactMultiChild = ReactMultiChild;
// window.dnn.ReactMultiChildUpdateTypes = ReactMultiChildUpdateTypes;
// window.dnn.ReactNodeTypes = ReactNodeTypes;
// window.dnn.ReactOwner = ReactOwner;
// window.dnn.ReactPerf = ReactPerf;
// window.dnn.reactProdInvariant = reactProdInvariant;
// window.dnn.ReactPropTypeLocationNames = ReactPropTypeLocationNames;
// window.dnn.ReactPropTypeLocations = ReactPropTypeLocations;
// window.dnn.ReactPropTypes = ReactPropTypes;
// window.dnn.ReactPropTypesSecret = ReactPropTypesSecret;
// window.dnn.ReactPureComponent = ReactPureComponent;
// window.dnn.ReactReconciler = ReactReconciler;
// window.dnn.ReactReconcileTransaction = ReactReconcileTransaction;
// window.dnn.ReactRef = ReactRef;
// window.dnn.ReactServerBatchingStrategy = ReactServerBatchingStrategy;
// window.dnn.ReactServerRendering = ReactServerRendering;
// window.dnn.ReactServerRenderingTransaction = ReactServerRenderingTransaction;
// window.dnn.ReactServerUpdateQueue = ReactServerUpdateQueue;
// window.dnn.ReactSimpleEmptyComponent = ReactSimpleEmptyComponent;
// window.dnn.ReactStateSetters = ReactStateSetters;
// window.dnn.ReactTestMount = ReactTestMount;
// window.dnn.ReactTestReconcileTransaction = ReactTestReconcileTransaction;
// window.dnn.ReactTestRenderer = ReactTestRenderer;
// window.dnn.ReactTestUtils = ReactTestUtils;
// window.dnn.ReactTransitionChildMapping = ReactTransitionChildMapping;
// window.dnn.ReactTransitionEvents = ReactTransitionEvents;
// window.dnn.ReactTransitionGroup = ReactTransitionGroup;
// window.dnn.ReactUMDEntry = ReactUMDEntry;
// window.dnn.ReactUpdateQueue = ReactUpdateQueue;
// window.dnn.ReactUpdates = ReactUpdates;
// window.dnn.ReactVersion = ReactVersion;
// window.dnn.ReactWithAddons = ReactWithAddons;
// window.dnn.ReactWithAddonsUMDEntry = ReactWithAddonsUMDEntry;
// window.dnn.renderSubtreeIntoContainer = renderSubtreeIntoContainer;
// window.dnn.ResponderEventPlugin = ResponderEventPlugin;
// window.dnn.ResponderSyntheticEvent = ResponderSyntheticEvent;
// window.dnn.ResponderTouchHistoryStore = ResponderTouchHistoryStore;
// window.dnn.SelectEventPlugin = SelectEventPlugin;
// window.dnn.setInnerHTML = setInnerHTML;
// window.dnn.setTextContent = setTextContent;
// window.dnn.shallowCompare = shallowCompare;
// window.dnn.shouldUpdateReactComponent = shouldUpdateReactComponent;
// window.dnn.SimpleEventPlugin = SimpleEventPlugin;
// window.dnn.sliceChildren = sliceChildren;
// window.dnn.SVGDOMPropertyConfig = SVGDOMPropertyConfig;
// window.dnn.SyntheticAnimationEvent = SyntheticAnimationEvent;
// window.dnn.SyntheticClipboardEvent = SyntheticClipboardEvent;
// window.dnn.SyntheticCompositionEvent = SyntheticCompositionEvent;
// window.dnn.SyntheticDragEvent = SyntheticDragEvent;
// window.dnn.SyntheticEvent = SyntheticEvent;
// window.dnn.SyntheticFocusEvent = SyntheticFocusEvent;
// window.dnn.SyntheticInputEvent = SyntheticInputEvent;
// window.dnn.SyntheticKeyboardEvent = SyntheticKeyboardEvent;
// window.dnn.SyntheticMouseEvent = SyntheticMouseEvent;
// window.dnn.SyntheticTouchEvent = SyntheticTouchEvent;
// window.dnn.SyntheticTransitionEvent = SyntheticTransitionEvent;
// window.dnn.SyntheticUIEvent = SyntheticUIEvent;
// window.dnn.SyntheticWheelEvent = SyntheticWheelEvent;
// window.dnn.TapEventPlugin = TapEventPlugin;
// window.dnn.TouchHistoryMath = TouchHistoryMath;
// window.dnn.Transaction = Transaction;
// window.dnn.traverseAllChildren = traverseAllChildren;
// window.dnn.update = update;
// window.dnn.validateDOMNesting = validateDOMNesting;
// window.dnn.ViewportMetrics = ViewportMetrics;